export default __webpack_public_path__ + "images/SL.471119b.png";